import { render, staticRenderFns } from "./ReportInteractionCard.vue?vue&type=template&id=206d0210"
import script from "./ReportInteractionCard.vue?vue&type=script&lang=js"
export * from "./ReportInteractionCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports